import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "../_keys";
import { Routes } from "../_routes";

import { urlMaker } from "utils";
import { onSuccessDeleteTypeOfMeeting } from "./helpers";

const deleteTypeOfMeeting = async ({ id }: DeleteTypeOfMeetingReqT) =>
  axios.delete(urlMaker(Routes.DELETE_TYPE_OF_MEETING, id));

export const useDeleteTypeOfMeeting = () =>
  useMutation({
    mutationKey: [Keys.DELETE_TYPE_OF_MEETING],
    mutationFn: deleteTypeOfMeeting,
    onSettled: onSuccessDeleteTypeOfMeeting,
    cacheTime: Infinity,
  });
